// extracted by mini-css-extract-plugin
module.exports = {"title":"card-title_title__csPve","clipped":"card-title_clipped__4oqzR"};